module.exports = __webpack_public_path__ + "static/media/community.72eeceac.svg";